module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD6SURBVHgBnZSBEYIwDEWjEzACbuAmMkJHYAO6AWygG+gGjNAR4ga6QWzOePZyKW15d7mDJvz+kAKAARF1McYY9xhIf4KsOaiFi2O8qAwWhWPBTO1MObGJ9jNbbZLRUgtDKogq6WX9RvXwe+8sd6jct4i6Y3zmol7nU90j1DOwg2Ba3zcoZIdntQuLObk+Qxv9gWWNxDvGSa4DF0ItlD8eq+R7VbPQ9/OzCLCRZK4iyt82T9snRqzpPzgx0jYru8x0pwfqfruXfgYoG/eJ2KRr0p0c1bNmDDhtf6H9+NzEPbWzQOEYcftYIcRtO6hFhPlIpZNEWeMBddZzHy2h9ROZRZ40AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/Phone.png
// module id = SFFe
// module chunks = 0